export default {
  LOGIN_CELULAR_SCREEN_DISPLAY_HEADER_TEXT: "Celular",
  LOGIN_CELULAR_SCREEN_DISPLAY_PLACEHOLDER: "6123-4567",

  LOGIN_CELULAR_SCREEN_HEADER_TEXT:
    "¡Vende rápido y fácil desde tu cel con Cuanto 🛍📲!",
} as const;
